export const numbersKeys = [
  'number_zero',
  'number_one',
  'number_two',
  'number_three',
  'number_four',
  'number_five',
  'number_six',
  'number_seven',
  'number_eight',
  'number_nine',
];

export const passwordCharacters = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
export const PASSWORD_LENGTH = 3;
